import React from 'react'
import { AgentLanguageValue } from '../../agent-language/agent-language'
import { AddExclusionDialog } from '../../application-exclusions/add-exclusion-dialog'
import {
  AttackEventForExclusion,
  getErrorMsg
} from '../../application-exclusions/shared'
import { useContrastMutation } from '../../../hooks/use-contrast-mutation'
import { HTTPError } from '../../../api/fetch/decorate-fetch'
import {
  suppressEventsFromExclusion,
  SuppressEventsFromExclusionApiResponse,
  SuppressEventsFromExclusionArgs
} from '../../application-exclusions/api/requests/suppress-events-from-exclusion'
import { logError, logSuccess } from '../../toaster'
import { useIntl } from 'react-intl'

interface Props {
  organizationUuid: string
  application: {
    id: string
    name: string
    language: AgentLanguageValue
  }
  attackEvent: AttackEventForExclusion
  isOpen: boolean
  closeDialog: () => void
  onExclusionAdded: (eventUuid?: string, eventsSuppressed?: number) => void
}

export function CreateRuleExclusionDialog({
  organizationUuid,
  application: { id, name: appName, language },
  attackEvent,
  isOpen,
  closeDialog,
  onExclusionAdded
}: Props) {
  const { mutate: suppressEvents } = useContrastMutation<
    SuppressEventsFromExclusionApiResponse,
    HTTPError,
    SuppressEventsFromExclusionArgs
  >(suppressEventsFromExclusion)

  const { formatMessage } = useIntl()

  return (
    <AddExclusionDialog
      closeDialog={closeDialog}
      organizationUuid={organizationUuid}
      applicationId={id}
      applicationName={appName}
      applicationLanguage={language}
      attackEvent={attackEvent}
      isOpen={isOpen}
      successCallback={(exclusionId, shouldSuppressEvents) => {
        if (shouldSuppressEvents) {
          suppressEvents(
            {
              organizationUuid,
              applicationId: id,
              exclusionId
            },
            {
              onSuccess: ({ count: eventsSuppressed }) => {
                let successMsg
                if (eventsSuppressed > 1) {
                  successMsg = formatMessage(
                    {
                      id: 'detail_attackEventExclusion_suppressedMultipleEvents'
                    },
                    { count: eventsSuppressed }
                  )
                } else if (eventsSuppressed === 1) {
                  successMsg = formatMessage({
                    id: 'detail_attackEventExclusion_suppressedSingleEvent'
                  })
                } else {
                  successMsg = formatMessage({
                    id: 'detail_attackEventExclusion_suppressedNoEvents'
                  })
                }

                logSuccess(successMsg)
                onExclusionAdded(attackEvent.uuid, eventsSuppressed)
              },
              onError: ({ data: { messages } }) => {
                logError(getErrorMsg(messages))
                onExclusionAdded(attackEvent.uuid)
              }
            }
          )
        } else {
          onExclusionAdded(attackEvent.uuid)
        }
      }}
      isAssessFeatureEnabled={true}
      isProtectFeatureEnabled={true}
      shouldAllowSuppressEvents={true}
    />
  )
}
